/***
 * Created on 2023/8/31
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useRef} from 'react';
import ModalDialog from "../../../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {apiPost, apiPut} from "../../../../../service/api";
import {useBoundedStore} from 'common/Store';
import {getLocalUser} from "../../../../../service/user";
import {QNAP_AUTH_APP_METHOD_MAP} from "../qnap_auth_app/qnap_auth_manager/qnap_auth_panel_row";
import {QnapAuthMethodDisplayName} from "../qnap_auth_app/qnap_auth_manager/qnap_auth_panel";


function RemovePhoneDialog({dispatch, state,  ...props}) {
    const { t } = useTranslation();
    const currentUser = getLocalUser();
    const store = useBoundedStore();
    const setDisable = useRef(false);

    const removeMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/two_step', data),
        onSuccess: data => {
            if (!setDisable.current) {
                props.closeModal();
                dispatch({type: 'updateSMSPanel'})
                store.globalAlert.setAlert(t('@Your device {{mobile_device_name}} has been removed@', {mobile_device_name: state?.opts?.qid}), 'success', true);
            }
            else {
                disableMutate.mutate({two_step_enabled: false});
            }
        },
        onError: (error, variables, context) => {}
    });

    const disableMutate = useMutation({
        mutationFn: async (data) => await apiPut(`/ajax/activate_two_step`, data),
        onSuccess: data => {
            console.log(data);
            dispatch({type: 'toggleSigninAgain', value: true});
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const onRemove = async () => {
        const data = {
            verify_type: state?.opts?.method,
            is_delete: true
        }
        await removeMutation.mutateAsync(data);
    }

    const showWarningMessage = () => {
        let message;
        if (currentUser?.secure?.qnap_auth?.settings?.default_method) {
            const method =  t(QnapAuthMethodDisplayName[QNAP_AUTH_APP_METHOD_MAP[currentUser?.secure?.qnap_auth?.settings?.default_method]]);
            message = t('@By removing the phone number "{{selected_phone_number}}", you will still be able to verify 2-step verification through {{default_method}}. However, this phone number will no longer be used for 2-step verification.@', {
                selected_phone_number: state?.opts?.qid,
                default_method: method,
            })
            message = `${message} ${t('@Do you want to remove it from your account?@')}`
        }
        else {
            message = t('@By removing the phone number "{{selected_phone_number}}", you currently have no other method set up for 2-step verification, and 2-step verification will be disabled.@', {
                selected_phone_number: state?.opts?.qid,
            });
            setDisable.current = true;
        }
        return message;
    }

    return (
        <ModalDialog {...props} title={state?.opts?.method === 'google_auth' ? t('@Remove Authenticator App@') : t('@Remove phone number@')} submitText={t('@Remove@')} submitAction={onRemove}>
            <div className="dialog-content">
                <p>{showWarningMessage()}</p>
            </div>
        </ModalDialog>
    );
}

export default RemovePhoneDialog;